/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementSelectiveProcessViewModel } from "../types/CourseRegistrationManagementSelectiveProcessViewModel.ts";
import { eSelectiveProcessAdmissionTypeSchema } from "./eSelectiveProcessAdmissionTypeSchema.ts";
import { eSelectiveProcessStatusSchema } from "./eSelectiveProcessStatusSchema.ts";

export const courseRegistrationManagementSelectiveProcessViewModelSchema =
  z.object({
    id: z.optional(z.number().int()),
    courseRegistrationId: z.optional(z.number().int()),
    status: z.optional(
      z
        .lazy(() => eSelectiveProcessStatusSchema)
        .describe(
          "1 = Registred | 2 = Approved | 3 = ReprovedDocumentation | 4 = ReprovedInterview | 5 = ReprovedExam | 6 = ReprovedPayment | 7 = Dropout | ",
        ),
    ),
    admissionType: z.optional(
      z
        .lazy(() => eSelectiveProcessAdmissionTypeSchema)
        .describe(
          "1 = Vestibular | 2 = Enem | 3 = SecondGraduation | 4 = VestibularWithSchoolHistory | ",
        ),
    ),
    entranceExamDate: z.string().datetime().nullish(),
    interviewDate: z.string().datetime().nullish(),
    isEntranceExam: z.optional(z.boolean()),
    isAttendEntranceExam: z.optional(z.boolean()),
    isDocumentationApproved: z.optional(z.boolean()),
    documentationRejectionReasonId: z.number().int().nullish(),
    entranceExamGrade: z.number().nullish(),
    essayGrade: z.number().nullish(),
  }) as unknown as ToZod<CourseRegistrationManagementSelectiveProcessViewModel>;
